import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberswitcher',
})
export class NumberswitcherPipe implements PipeTransform {

  transform(value: number | string, switcher: number, numbs: number): string {
    if (!numbs) {
      numbs = 0;
    }
    if (!value) {
      return '-';
    }
    value = Number(value);
    if (!isFinite(value)) {
      return '-';
    }
    if (switcher === 1) {
      return value.toFixed(numbs) === '-0' ? '-' : (value).toFixed(numbs).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    if (switcher === 1000) {
      return (value / 1000).toFixed(numbs).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'k';
    }

    if (switcher > 10000) {
      return (value / 1000000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'm';
    }
  }
}
